import React, { useState } from 'react';
import AssestsTable from '../../Components/Assest/AssestsTable';
import ButtonPlus from '../../Components/SelectValue/ButtonPlus';
import AddAssest from '../../Components/Assest/AddAssests';
import CreateAssestCategory from '../../Components/Assest/CreateAssetCategory';
import UserHistoryTable from '../../Components/Assest/UserHistoryTable';
import AssetFinancingMgt from '../../Components/Assest/AssetFinancingMgt';
import CustomAssetRequest from '../../Components/Assest/CustomAssetRequest';
import { isFinanceManager } from '../../utils/permissions';
import RepaymentTenure from '../../Components/Assest/RepaymentTenure';

function AssestFunding() {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [activeTab, setActiveTab] = useState('Asset Management');
  const [titleFilter, setTitleFilter] = useState('');
  const readOnly = isFinanceManager();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const tabs = [
    'Asset Management',
    'Asset Requests',
    'Custom Asset Request',
    'Repayment Tenure',
    
  ];

  return (
    <div>
      <AddAssest open2={open} handleClose2={handleClose} onCreateCategory={handleOpen2} />
      <CreateAssestCategory open={open2} handleClose={handleClose2} />
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-[#0A0F46] text-[20px] font-[500]">Filter assets</h1>
        {!readOnly && (
          <div className="flex gap-4">
            <ButtonPlus name={'Add Asset'} onClick={handleOpen} />
            <ButtonPlus name={'Create Category'} onClick={handleOpen2} />
          </div>
        )}
      </div>
      <div className="flex mb-4 space-x-4">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 rounded-t-lg ${
              activeTab === tab
                ? 'font-normal text-[14px] inline-block text-back-color2 border-b-2 border-primary-color pb-2 text-center'
                : 'font-normal text-[14px] inline-block text-back-color2 pb-2 text-center'
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="mb-4">
      </div>
      {activeTab === 'Asset Management' && <AssestsTable titleFilter={titleFilter} readOnly={readOnly} />}
      {activeTab === 'Asset Requests' && (
        <AssetFinancingMgt />
      )}
      {activeTab === 'Custom Asset Request' && (
          <CustomAssetRequest readOnly={readOnly} />
      )}
      {activeTab === 'Repayment Tenure' && <RepaymentTenure />}
    </div>
  );
}

export default AssestFunding;
